import type { MRT_ColumnFiltersState } from "mantine-react-table";

export interface ActiveFilter {
    id: string;
    field: string;
    label: string;
    value: string;
}

const fieldFromId = (id: string): string => id.split("__").slice(1).join("__");

export const describeActiveFilters = ({
    columnFilters,
    labelById,
}: {
    columnFilters: MRT_ColumnFiltersState;
    labelById?: Map<string, string>;
}): ActiveFilter[] =>
    columnFilters
        .filter((filter) => typeof filter.value === "string" && filter.value.trim().length > 0)
        .map((filter) => {
            const field = fieldFromId(filter.id);
            return {
                id: filter.id,
                field,
                label: labelById?.get(filter.id) || field.replace(/^metadata\./, ""),
                value: filter.value as string,
            };
        });
